const s = {
  name: "Number3Circle",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<path class="st0" d="M22,21h-6v-2h6v-3h-6v-2h8v12h-8v-2h6V21z"/>
<path class="st0" d="M0,20C0,9,9,0,20,0s20,9,20,20s-9,20-20,20S0,31,0,20z M20,2C10.1,2,2,10.1,2,20s8.1,18,18,18s18-8.1,18-18
	S29.9,2,20,2z"/>
</svg>
  `
};
export {
  s as Number3Circle
};
